import { memo } from 'react';

import { usePublicClipAssetShare } from '~/components/AssetModalV2/Header/PublicAssetComponents/usePublicClipAssetShare';
import { PublicAssetHeader } from '~/components/AssetModalV2/Header/PublicAssetHeader';
import {
  PublicAssetModalDesktopLayout,
  type PublicAssetModalDesktopLayoutProps,
} from '~/components/AssetModalV2/PublicAssetModalDesktopLayout';

export type PublicClipAssetModalDesktopLayoutProps = Pick<PublicAssetModalDesktopLayoutProps, 'onCloseAssetModal'>;

export const PublicClipAssetModalDesktopLayout = memo(
  ({ onCloseAssetModal }: PublicClipAssetModalDesktopLayoutProps) => {
    const { sharePublicClipAsset } = usePublicClipAssetShare();

    return (
      <PublicAssetModalDesktopLayout
        header={<PublicAssetHeader />}
        onCloseAssetModal={onCloseAssetModal}
        onShare={sharePublicClipAsset}
        showFullscreenNavigationArrows={false}
      />
    );
  },
);

PublicClipAssetModalDesktopLayout.displayName = 'PublicClipAssetModalDesktopLayout';
